import { supportedLanguagesRegExp } from './supportedLanguagesRegExp';

export const changeLanguageInPathname = (pathname: string, language: string): string => {
  if (supportedLanguagesRegExp.test(pathname)) {
    return (
      '/' + pathname.replace(supportedLanguagesRegExp, language === 'en' ? '' : language + '/')
    );
  }

  const pathWithoutLang = pathname.replace(/^\/[a-z]{2}(?=\/|$)/, '');
  return `${language === 'en' ? '' : '/' + language}${pathWithoutLang}`;
};
